import { Sport } from '@sorare/core/src/__generated__/globalTypes';

const ESTIMATED_CASH_PRIZE_IN_USER_CURRENCY = 200000;
const ESTIMATED_CASH_PRIZE_IN_USER_CURRENCY_MLB = 25000;

export const estimatedCashPrizeInUserCurrency = {
  [Sport.BASEBALL]: ESTIMATED_CASH_PRIZE_IN_USER_CURRENCY_MLB,
  [Sport.FOOTBALL]: ESTIMATED_CASH_PRIZE_IN_USER_CURRENCY,
  [Sport.NBA]: ESTIMATED_CASH_PRIZE_IN_USER_CURRENCY,
};
